import { hot } from 'react-hot-loader';
import React from 'react';
import View from './View';

const PrivacyComponent = ({ data, location }) => {
  return <View data={data} location={location} />
};

export const Privacy = hot(module)(PrivacyComponent);
